export class GChartAxisSplitLine {
  show = true;

  public constructor(init?: Readonly<GChartAxisSplitLine>) {
    Object.assign(this, init);
  }
}
